import React from 'react'
import { useLocation } from 'react-router-dom'
import GlobalSearch from '../../../components/Layouts/NewAppLayout/GlobalSearch/GlobalSearch'

const DashboardHeader = ({ dateFilter = 'year', onDateFilterChange, profile }) => {
  const location = useLocation()
  const { pathname } = location

  const handleDateFilterClick = (filter) => {
    if (onDateFilterChange) {
      onDateFilterChange(filter)
    }
  }

  const getActiveClass = (filter) => {
    return dateFilter === filter ? 'active' : ''
  }

  // Extract username from profile
  const getUserName = () => {
    if (!profile) return 'User'
    
    if (profile.name) {
      return profile.name
    }
    
    const firstName = profile.first_name || ''
    const lastName = profile.last_name || ''
    const fullName = `${firstName} ${lastName}`.trim()
    
    return fullName || 'User'
  }

  return (
    <>
      {/* Card Header */}
      <div className="sh_cardHeader">
        <div className="d-flex flex-column">
          <div className="d-flex position-relative sh_pagetopsubheader">
            <h2 className="h2-strong position-absolute  sh_welcome-text">Welcome {getUserName()}!</h2>
            <div className="d-flex justify-content-center align-items-center sh_pagetopsubheadersearch" style={{ flex: 1 }}>
              {profile &&
                profile.is_multiple_organization === false &&
                profile.employee_login === false && (
                  <GlobalSearch
                    pathname={pathname}
                  />
                )}
            </div>
            <div>
              <span className="">
                <div
                  id="collapsemenu"
                  className="collapse "
                  style={{ zIndex: 1045, top: '60px', left: '25%', right: '25%', position: 'absolute' }}
                >
                  <div className="collapse-inner mb-0">
                    <div className="sh_modalBox shadow-lg">
                      <div className="modal-header">
                        <h6 className="text-lg mb-0 font-weight-bold">Additional Search</h6>
                        <a className="btn-close text-sm" style={{ cursor: 'pointer' }}></a>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-6">
                            <div className="form-group mb-1">
                              <label className="text-sm text-truncate mb-0 opacity-75">Company</label>
                              <div>
                                <select className="form-control form-control-solid " name="company_id" id="">
                                  <option value="">-Select Company-</option>
                                  <option value="20ebd11df5e14477a7e3fe7ca9b19f3a">HCL</option>
                                  <option value="bd8d4daca743473eb953345032275338">Info Company</option>
                                  <option value="3bc0251d95ba4bab960640216fba02b7">Moon Industry</option>
                                  <option value="c39e19be0f4741b0a0b45ad9d26b4bba">Protech </option>
                                  <option value="a8defd79c4694beaa425163979604ce0">Vecna Tech</option>
                                  <option value="a29f9b2b5b5d449b9c20b11ba8ba67d8">Zoho</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group mb-1">
                              <label className="text-sm text-truncate mb-0 opacity-75">Visit Category</label>
                              <div>
                                <select className="form-control form-control-solid " name="visit_category" id="">
                                  <option value="">-Select-</option>
                                  <option value="----- EMPLOYER SERVICES -----">----- EMPLOYER SERVICES -----</option>
                                  <option value="Employer Services - Drug Screens">Employer Services - Drug Screens</option>
                                  <option value="Employer Services - Labs">Employer Services - Labs</option>
                                  <option value="Employer Services - Physicals">Employer Services - Physicals</option>
                                  <option value="Employer Services - Vaccines">Employer Services - Vaccines</option>
                                  <option value="----- WORK COMP -----">----- WORK COMP -----</option>
                                  <option value="Work Comp - New Injury">Work Comp - New Injury</option>
                                  <option value="Work Comp - Follow Up">Work Comp - Follow Up</option>
                                  <option value="Work Comp - Physical Therapy">Work Comp - Physical Therapy</option>
                                  <option value="Work Comp - Other">Work Comp - Other</option>
                                  <option value="----- URGENT CARE -----">----- URGENT CARE -----</option>
                                  <option value="Urgent Care - Injury">Urgent Care - Injury</option>
                                  <option value="Urgent Care - Illness">Urgent Care - Illness</option>
                                  <option value="Urgent Care - Follow Up">Urgent Care - Follow Up</option>
                                  <option value="Urgent Care - Cash Patient">Urgent Care - Cash Patient</option>
                                  <option value="Urgent Care - Drug Screens">Urgent Care - Drug Screens</option>
                                  <option value="Urgent Care - Labs Only">Urgent Care - Labs Only</option>
                                  <option value="Urgent Care - Physicals">Urgent Care - Physicals</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group mb-1">
                              <label className="text-sm text-truncate mb-0 opacity-75">Visit Status</label>
                              <div>
                                <select className="form-control form-control-solid " name="visit_status" id="">
                                  <option value="">-Select-</option>
                                  <option value="----- INCOMING VISITS -----">----- INCOMING VISITS -----</option>
                                  <option value="New">New</option>
                                  <option value="Waiting Room">Waiting Room</option>
                                  <option value="Checked In">Checked In</option>
                                  <option value="----- EXAM ROOMS -----">----- EXAM ROOMS -----</option>
                                  <option value="Exam 1">Exam 1</option>
                                  <option value="Exam 2">Exam 2</option>
                                  <option value="Exam 3">Exam 3</option>
                                  <option value="Exam 4">Exam 4</option>
                                  <option value="Exam 5">Exam 5</option>
                                  <option value="Exam 6">Exam 6</option>
                                  <option value="Exam 7">Exam 7</option>
                                  <option value="Exam 8">Exam 8</option>
                                  <option value="Exam 9">Exam 9</option>
                                  <option value="----- OTHER ROOMS -----">----- OTHER ROOMS -----</option>
                                  <option value="Audio Booth">Audio Booth</option>
                                  <option value="DS Station 1">DS Station 1</option>
                                  <option value="----- DISCHARGE -----">----- DISCHARGE -----</option>
                                  <option value="Ready for Discharge">Ready for Discharge</option>
                                  <option value="Complete & Discharged">Complete & Discharged</option>
                                  <option value="Cancelled">Cancelled</option>
                                  <option value="No Show">No Show</option>
                                  <option value="----- SELF REGISTRATION -----">----- SELF REGISTRATION -----</option>
                                  <option value="Employer Pre-Reg">Employer Pre-Reg</option>
                                  <option value="Employee Pre-Reg">Employee Pre-Reg</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group mb-1">
                              <label className="text-sm text-truncate mb-0 opacity-75"></label>
                              <div>
                                <input
                                  type="text"
                                  id=""
                                  className="form-control form-control-solid "
                                  name="cup_id"
                                  placeholder="Cup ID"
                                  value=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center modal-footer py-0">
                        <button type="button" className="btn btn-outline-secondary">Clear</button>
                        <button type="button" className="btn btn-primary">Search</button>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="sh_cardHeader bg-white">
        <div className="form-group d-flex mb-0 justify-content-start align-items-center mt-1">
          <div className="ml-2">
            <div className="tabs_wrapForTable">
              <ul className="nav sh_subnav border-0">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleDateFilterClick('today')
                    }}
                    className={`flex-sm-fill text-sm-center text-dark nav-link ${getActiveClass('today')}`}
                    aria-current={dateFilter === 'today' ? 'page' : undefined}
                  >
                    Today
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleDateFilterClick('yesterday')
                    }}
                    className={`flex-sm-fill text-sm-center text-dark nav-link ${getActiveClass('yesterday')}`}
                  >
                    Yesterday
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleDateFilterClick('week')
                    }}
                    className={`flex-sm-fill text-sm-center text-dark nav-link ${getActiveClass('week')}`}
                  >
                    Week
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleDateFilterClick('month')
                    }}
                    className={`flex-sm-fill text-sm-center text-dark nav-link ${getActiveClass('month')}`}
                  >
                    Month
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault()
                      handleDateFilterClick('year')
                    }}
                    className={`flex-sm-fill text-sm-center text-dark nav-link font-weight-bold ${getActiveClass('year')}`}
                    aria-current={dateFilter === 'year' ? 'page' : undefined}
                  >
                    Year
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DashboardHeader




